import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpResponse, HttpErrorResponse,
} from '@angular/common/http';
import { tap, finalize } from 'rxjs/operators';
import {LoadingService} from "../services/loader/loading.service";
import {Observable} from "rxjs";
import {Router} from "@angular/router";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private token: string | null = "";
  private activeRequests = 0;


  constructor(private loadingService: LoadingService, private router: Router) {


  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.activeRequests === 0) {
       this.loadingService.show();
    }
    this.activeRequests++;
    if (localStorage.getItem('LoginData') != null ) {
      this.token = localStorage.getItem('LoginData');
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.token}`
        }
      });
    }

    return next.handle(request).pipe(
        finalize(() => {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.loadingService.hide();
          }
        }),
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Handle successful responses here
        }
      },
          (error: any) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            localStorage.removeItem('LoginData');
            localStorage.removeItem('CurrentUser');
            this.router.navigate(['/login']);
          }
          if (error.status === 500) {
            window.location.href = '/pages/under-maintenance';
          }
        }
      }));
  }
}
